import React, {PureComponent, PropTypes} from 'react';
import InstantBookingProgressBarPane from 'components/InstantBookingProgressBarPane';
import TotalPrice from './TotalPrice';
import InfoBlockParametersIcons from './InfoBlockParametersIcons';

import './SidebarHeaderBlock.scss';
import isMobile from "ismobilejs";
import ga from "react-ga";


import ActionCreators from 'actions/ActionCreators';
import InstantBookingStore from 'stores/InstantBookingStore';
import CategoryStore from 'stores/CategoryStore';
import ParametersStore from 'stores/ParametersStore';
import UserStore from 'stores/UserStore';
import IconSVG from 'svg-inline-react'
import {Map} from "immutable";

// import RouteStore from 'stores/RouteStore';

function getStateFromStores() {
    return {
        price: InstantBookingStore.getPrice(),
        showInstantBookingContacts: InstantBookingStore.showInstantBooking(),
        selectedCategory: CategoryStore.getSelected(),
        parameters: ParametersStore.getDeliveryParameters(),
        userHasToken: UserStore.hasToken(),
        userHasVVauthorization: UserStore.hasVVauthorization(),
        userHasAccount: UserStore.hasAccount(),
        isLoadersSaved: InstantBookingStore.isLoadersSaved(),
        date: InstantBookingStore.getPartDay(),
        partDay: InstantBookingStore.getPartDay(),
        services: InstantBookingStore.getServices(),
        /*locations: RouteStore.getLocations(),*/
    }
}

class SidebarHeaderBlock extends PureComponent {

    static propTypes = {
        location: PropTypes.object,
        onChangeService: PropTypes.func,
    };

    constructor(props) {
        super(props);
        const storeStates = getStateFromStores();

        this.state = {
            ...storeStates,
            errors: {},
        }
    }

    componentDidMount() {
        InstantBookingStore.addChangeListener(this._onChange);
        ParametersStore.addChangeListener(this._onChange);
        UserStore.addChangeListener(this._onChange);
        /*RouteStore.addChangeListener(this._onChange);*/
    }

    componentWillUnmount() {
        InstantBookingStore.removeChangeListener(this._onChange);
        ParametersStore.removeChangeListener(this._onChange);
        UserStore.removeChangeListener(this._onChange);
        /*RouteStore.removeChangeListener(this._onChange);*/
    }

    _onChange = () => {
        this.setState(getStateFromStores());
    };

    onCalendarFinish = () => {
        let stage = '';
        const location = this.props.location.query;

        if (this.state.showInstantBookingContacts) {
            stage = `/category/${this.state.selectedCategory.name}/instant-final-info`;
        } else {
            stage = `/category/${this.state.selectedCategory.name}/contacts`;
        }

        // TODO Add server validation
        if (!this.state.price) {
            alert('Выберите дату!')
            return
        }

        if (!this.state.isLoadersSaved) {
            alert('У вас есть несохраненные изменения в грузчиках. Для начала отмените либо сохраните их!')
            return
        }

        ActionCreators.showLoadingOverlay()

        InstantBookingStore.validate().then(
            done => {
                ga.event({
                    category: 'orders',
                    action: 'add_orders_new_s4_from_instant_booking',
                    label: this.state.selectedCategory.name,
                    value: 1,
                })

                if (window.ym) {
                    window.ym('1315865', 'reachGoal', 'add_orders_new_s4_from_instant_booking');
                }

                this.setState({
                    errors: {},
                }, () => {
                    ActionCreators.hideLoadingOverlay()
                    ActionCreators.setStage(stage, location)
                    ActionCreators.setTimeIsSelected(true);
                })
            },
            errors => {
                ActionCreators.hideLoadingOverlay()

                // Validation errors, don't go to next step!
                if (errors) {
                    this.setState({
                        errors,
                    })
                    return
                }

                ActionCreators.setStage(stage, location)
            },
        )
    };

    render() {
        return (
            <div className="SidebarHeaderBlock">
                {
                    !this.state.date.size &&
                    <InstantBookingProgressBarPane/>
                }

                <TotalPrice
                    errors={this.state.errors}
                    parameters={this.state.parameters}
                    price={this.state.price}
                    submitText="К бронированию"
                    onSubmit={this.onCalendarFinish} />

                <InfoBlockParametersIcons
                    parameters={this.state.parameters}
                    partDay={this.state.partDay}
                    onChangeService={this.props.onChangeService}
                    services={this.state.services}/>
            </div>
        )
    }
}

export default SidebarHeaderBlock;



// WEBPACK FOOTER //
// ./client/components/SidebarHeaderBlock/SidebarHeaderBlock.js